








import Vue from 'vue'

export default Vue.extend({
  name: 'ShowBankName',
  props: {
    bankName: String
  }
})
